// ingest-batch-id.ts — CTSK-500 (Stage 2a of CTSK-497).
//
// One label shared by every file dropped or picked together in ONE action.
// The web client mints it (ULID, Crockford base32) and sends it as the
// `ingestBatchId` multipart field of POST /documents/upload; the API stamps it
// on documents.ingest_batch_id (migration 0068) while document grouping is on
// for the org. It is a label inside one org: never use it for authorization
// or ownership.
//
// ONE normaliser, used by the upload route, the list filter and the web
// helper's own tests, so the rule cannot drift. It never throws: a malformed
// value is `null`, and callers treat null as "no batch" (the upload still
// succeeds, the list filter matches nothing).
/** 26 chars of Crockford base32 (no I, L, O, U), upper case. */
export const INGEST_BATCH_ID_REGEX = /^[0-9A-HJKMNP-TV-Z]{26}$/;
export const INGEST_BATCH_ID_LENGTH = 26;
/** Name of the multipart field on POST /documents/upload. */
export const INGEST_BATCH_ID_FIELD = 'ingestBatchId';
/**
 * Trim, then require an exact match against {@link INGEST_BATCH_ID_REGEX}.
 * Case is NOT folded: a lower-case ULID is malformed. Anything that is not a
 * string, or does not match, returns `null`.
 */
export function normalizeIngestBatchId(value) {
    if (typeof value !== 'string')
        return null;
    const v = value.trim();
    return INGEST_BATCH_ID_REGEX.test(v) ? v : null;
}
//# sourceMappingURL=ingest-batch-id.js.map